import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 relative bg-slate-900/50 border-y border-white/5" data-id="element-102">
      <div className="container mx-auto px-4" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center p-10 md:p-16 rounded-3xl bg-gradient-to-b from-slate-800/50 to-slate-900/50 border border-white/10" data-id="element-104">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-blue-500/10 text-blue-400 mb-8 border border-blue-500/20" data-id="element-105">
            <ShieldCheck size={40} data-id="element-106" />
          </div>

          <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-8" data-id="element-107">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <div className="space-y-4 text-lg text-slate-300 mb-8" data-id="element-108">
            <p data-id="element-109">Abrís los tomos. Aplicás los protocolos.</p>
            <p className="font-medium text-white" data-id="element-110">
              Si en 7 días no es lo que esperabas: devolución del 100% — sin
              formularios, sin drama.
            </p>
          </div>

          <div className="pt-8 border-t border-white/10" data-id="element-111">
            <p className="text-sm text-slate-400 uppercase tracking-widest font-bold mb-2" data-id="element-112">
              Tasa de devoluciones: menos del 1%.
            </p>
            <p className="text-blue-400 font-medium italic" data-id="element-113">
              Porque quienes lo aplican, duermen mejor.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}